export function getElementWidth(element) {
  if (window.getComputedStyle) {
    var computedStyle = getComputedStyle(element, null)
    return parseFloat(computedStyle.width)
  } else {
    return getPixelValue(element, element.currentStyle.width) + 'px'
  }
}

export function getElementHeight(element) {
  if (window.getComputedStyle) {
    var computedStyle = getComputedStyle(element, null)
    return parseFloat(computedStyle.height)
  } else {
    return getPixelValue(element, element.currentStyle.height) + 'px'
  }
}

var PIXEL = /^\d+(px)?$/i
function getPixelValue(element, value) {
  if (PIXEL.test(value)) return parseInt(value)
  var style = element.style.left
  var runtimeStyle = element.runtimeStyle.left
  element.runtimeStyle.left = element.currentStyle.left
  element.style.left = value || 0
  value = element.style.pixelLeft
  element.style.left = style
  element.runtimeStyle.left = runtimeStyle
  return value
}

export function getScrollbarWidth() {
  var outer = document.createElement('div')
  outer.style.visibility = 'hidden'
  outer.style.width = '100px'
  outer.style.msOverflowStyle = 'scrollbar' // needed for WinJS apps

  document.body.appendChild(outer)

  var widthNoScroll = outer.offsetWidth
  // force scrollbars
  outer.style.overflow = 'scroll'

  // add innerdiv
  var inner = document.createElement('div')
  inner.style.width = '100%'
  outer.appendChild(inner)

  var widthWithScroll = inner.offsetWidth

  // remove divs
  outer.parentNode.removeChild(outer)

  return widthNoScroll - widthWithScroll
}

//Returns true if it is a DOM element
export const isDomElement = (o) =>
  typeof HTMLElement === 'object'
    ? o instanceof HTMLElement //DOM2
    : o &&
      typeof o === 'object' &&
      o !== null &&
      o.nodeType === 1 &&
      typeof o.nodeName === 'string'

//Returns true if it is a DOM node
export const isDomNode = (o) =>
  typeof Node === 'object'
    ? o instanceof Node
    : o &&
      typeof o === 'object' &&
      typeof o.nodeType === 'number' &&
      typeof o.nodeName === 'string'

export const getIntersection = (o1, o2) => {
  const r1 = o1.getBoundingClientRect()
  const r2 = o2.getBoundingClientRect()
  return new DOMRect(
    Math.max(r1.x, r2.x),
    Math.max(r1.y, r2.y),
    Math.min(r1.right, r2.right) - Math.max(r1.x, r2.x),
    Math.min(r1.bottom, r2.bottom) - Math.max(r1.y, r2.y)
  )
}
